import { render, staticRenderFns } from "./loading-content.vue?vue&type=template&id=2430b654&scoped=true"
import script from "./loading-content.vue?vue&type=script&lang=ts"
export * from "./loading-content.vue?vue&type=script&lang=ts"
import style0 from "./loading-content.vue?vue&type=style&index=0&id=2430b654&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2430b654",
  null
  
)

export default component.exports